import React from 'react'
import { I18n } from 'react-redux-i18n'
import ReactTooltip from 'react-tooltip'
import { getStaticImage } from 'utils/statics'

const CHANNEL_WITH_ALERTS = ['android', 'ios', 'imap', 'imap_yahoo', 'imap_icloud', 'imap_aol', 'gmail', 'outlook', 'office360', 'exchange', 'whatsapp']
const STATE_TO_DISPLAY = ['PENDING', 'REQUESTED', 'IN_PROGRESS', 'SYNC_ERROR']

const INFORMATION_BY_STATE = {
  PENDING: {
    tooltip: 'dashboard_pending-publication',
    icon: '/icons/icon-warning.svg'
  },
  REQUESTED: {
    tooltip: 'dashboard_requested-publication',
    icon: '/icons/icon-warning-yellow.svg'
  },
  IN_PROGRESS: {
    tooltip: 'dashboard_publication-in-progress',
    icon: '/icons/icon-warning-gray-white.svg'
  },
  SYNC_ERROR: {
    tooltip: 'dashboard_resynchronize',
    icon: '/icons/icon-warning-red.svg'
  },
  PENDING_WHATSAPP: {
    tooltip: 'dashboard_pending-verification',
    icon: '/icons/icon-warning.svg'
  },
}

/**
 * Component ChannelStatus
 * @param {object} props
 * @param {string} props.channel
 * @param {string} props.state
 * @param {string} props.tipId
 *
 * @returns {Component}
 */
function ChannelStatus(props) {
  return (
    <div className='status'>
      <Status {...props} />
    </div>
  )
}

function Status(props) {
  const { channel, state, tipId } = props
  if (!CHANNEL_WITH_ALERTS.includes(channel)) return null
  if (!STATE_TO_DISPLAY.includes(state)) return null

  const { tooltip, icon } = (channel !== 'whatsapp' ? INFORMATION_BY_STATE[state] : INFORMATION_BY_STATE[`${state}_${channel}`.toUpperCase()]) || {}

  return (
    <>
      <figure
        className='app-alert'
        data-tip={tooltip ? I18n.t(tooltip) : null}
        data-for={tipId}
      >
        <img
          src={tooltip ? getStaticImage(icon) : null}
          alt='App alert'
        />
      </figure>
      <ReactTooltip effect='solid' id={tipId} multiline={true} />
    </>
  )
}

export default ChannelStatus